/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AnalyticsInputs */

const en_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const de_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysen`)
};

const fr_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const es_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis`)
};

const it_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi`)
};

const nl_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses`)
};

const pl_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizy`)
};

const fi_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikka`)
};

const da_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

const sv_nav_analytics = /** @type {(inputs: Nav_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Nav_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_analytics = /** @type {((inputs?: Nav_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_analytics(inputs)
	if (locale === "fr") return fr_nav_analytics(inputs)
	if (locale === "es") return es_nav_analytics(inputs)
	if (locale === "it") return it_nav_analytics(inputs)
	if (locale === "nl") return nl_nav_analytics(inputs)
	if (locale === "pl") return pl_nav_analytics(inputs)
	if (locale === "fi") return fi_nav_analytics(inputs)
	if (locale === "da") return da_nav_analytics(inputs)
	if (locale === "sv") return sv_nav_analytics(inputs)
	return en_nav_analytics(inputs)
});